
import { mapGetters } from 'vuex'
import InnerLoading from '../Shared/Loading/InnerLoading.vue'
import Checkbox from '../Shared/Checkbox.vue'
export default {
  components: { InnerLoading, Checkbox },
  data() {
    return {
      loading: false,
      definations: [],
      allDefinations: [],
      definitionIsLoading: true,
      user: {
        id: -1,
        fullname: '',
        email: '',
        phone: '',
      },
      alertBox: {
        status: false,
        message: '',
        variant: '',
      },
    }
  },
  computed: {
    ...mapGetters({
      getActiveUser: 'user/getActiveUser',
    }),
  },
  methods: {
    CHECK_LENGTH(validations, key) {
      const validation = validations.find((val) => val.includes(key))
      if (validation) {
        const getLength = validation
          .substring(0, validation.length - 1)
          .split('(')[1]
        if (isNaN(Number(getLength))) return false
        else return Number(getLength)
      } else return false
    },
    async GET_FILE(e, defination, index) {
      const files = e.target.files
      if (defination.type === 'file') {
        const file = files[0]
        const fd = new FormData()
        fd.append('file', file)
        const response = 'dosya' //await this.$api.post('saveImage');
        this.definations[index].value = response
      }
    },
    async UPDATE_DEFINITION(defination, index) {
      if (defination.constValue !== defination.value && defination.mockDatasId)
        await this.$api.put(`MockDatas/${defination.mockDatasId}`, {
          value: defination.value,
        })
      else if (defination.constValue !== defination.value) {
        await this.$api.post('MockDatas', [
          {
            code: defination.code,
            dataId: this.user.id,
            dataType: 'User',
            value: defination.value,
          },
        ])
        this.GET_ALL_DEFINATIONS()
      }

      this.definations[index].constValue = defination.value
    },
    async GET_ALL_DEFINATIONS() {
      this.definitionIsLoading = true
      const response = await this.$api.get(
        `Definitions?useType=Register&lang=${this.$i18n.locale}`
      )
      if (response.message === 'OK') {
        this.allDefinations = response.data
          .map((d) => ({
            ...d,
            value: null,
            file: null,
            validations: d.validations.split(','),
          }))
          .filter((dat) => dat.language === this.$i18n.locale)
      } else this.allDefinations = []
      this.GET_DEFINATIONS(this.allDefinations)

      this.definitionIsLoading = false
    },
    async GET_DEFINATIONS(allDefinations) {
      this.definitionIsLoading = true
      const response = await this.$api.get(
        `MockDatas?dataType=User&dataId=${this.user.id}`
      )
      if (response.message === 'OK') {
        this.definations = allDefinations
          .map((d) => {
            const def = response.data.find((def) => def.code === d.code)
            return {
              ...d,
              value: def ? def.value : null,
              constValue: def ? def.value : null,
              mockDatasId: def ? def.id : null,
              ...(def?.definitions
                .map((m) => ({
                  ...m,
                  validations: m.validations.split(','),
                }))
                .find((def) => def.language === this.$i18n.locale) || {}),
            }
          })
          // this.definations = response.data
          //   .map((d) => ({
          //     ...d,
          //     constValue: d.value,
          //     mockDatasId: d.id,
          //     ...(d.definitions
          //       .map((m) => ({
          //         ...m,
          //         validations: m.validations.split(','),
          //       }))
          //       .find((def) => def.language === this.$i18n.locale) || {}),
          // }))
          .filter(
            (dat) => dat.language === this.$i18n.locale && dat.type !== 'file'
          )
      } else this.definations = []
      this.definitionIsLoading = false
    },
    async SEND_TO_UPDATE_USER(e) {
      e.preventDefault()
      this.loading = true
      this.alertBox = await this.$store.dispatch('user/SEND_TO_UPDATE_USER', {
        user: this.user,
        definations: this.definations.map((def) => ({
          id: def.id,
          value: def.value,
        })),
      })
      this.loading = false
      setTimeout(() => {
        if (this.alertBox.variant === 'success') {
          this.alertBox.status = false
        }
      }, 2500)
    },
  },
  created() {
    this.user = {
      id: this.getActiveUser.id,
      fullname: this.getActiveUser.fullname,
      email: this.getActiveUser.email,
      phone: this.getActiveUser.phone,
    }
    this.GET_ALL_DEFINATIONS()
  },
}
